// extracted by mini-css-extract-plugin
export default {"root":"SecondaryLayout_root__8o4Iu","backButton":"SecondaryLayout_backButton__HUIWd"};